import { PierhippnvRoutingModule } from './pierhippnv-routing.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { A11yModule } from '@angular/cdk/a11y';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertComponent } from './dialog/alert.component';
import { NvformComponent } from './nvform/nvform.component';
import { PIERHIPPNVComponent } from './pierhippnv.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { CustommatdateService } from './services/custommatdate.service';
import { DataService } from './services/data.service';
import { EventBusService } from './services/event-bus.service';
import { FocusFirstInvalidFieldDirective } from './services/form.directive';
import { PreserveHtmlPipe } from './services/preserve-html.pipe';
import { UppercaseInputDirective } from './services/uppercase-input.directive';
import { TimerComponent } from './timer/timer.component';

@NgModule({
  declarations: [
    PIERHIPPNVComponent,
    NvformComponent,
    AlertComponent,
    UppercaseInputDirective,
    PreserveHtmlPipe,
    FocusFirstInvalidFieldDirective,
    ScrollTopComponent,
    TimerComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatRadioModule,
    MatDialogModule,
    ReactiveFormsModule,
    HttpClientModule,
    MomentDateModule,
    MatTooltipModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    A11yModule,
    PierhippnvRoutingModule,
    MatSlideToggleModule,
    MatAutocompleteModule
  ],
  providers: [
    DataService,
    EventBusService,
    CustommatdateService,
    { provide: 'Window', useFactory: () => window },
  ],
})
export class PierhippnvModule { }

